import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { getAllSports } from "src/api/services/Sports";
import { useMutation } from "react-query";
import { CButton, CCard, CCardBody } from "@coreui/react";
import CustomLoader from "src/components/UI/Loader/Loader";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const DocumentTypes = [
    {
        id: 1,
        name: "Result Bracket"
    },
    {
        id: 2,
        name: "Result Fixer"
    },
    {
        id: 3,
        name: "Event List by List"
    },
    {
        id: 4,
        name: "Save List"
    },

];


function Index() {
    const [token] = useState(
        JSON.parse(localStorage.getItem("authtoken"))?.token || ""
    );
    const [documentTitle, setDocumentTitle] = useState("");
    const [selectedSport, setSelectedSport] = useState("");
    const [selectedSportId, setSelectedSportId] = useState(null);
    const [disciplines, setDisciplines] = useState([]);
    const [sports, setSports] = useState([]);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [documentType, setDocumentType] = useState("");
    const [pdfFile, setPdfFile] = useState(null);
    const [allReports, setAllReports] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [event, setEvent] = useState(null);

    const [editedData, setEditedData] = useState({
        from_date: "",
        end_date: "",
        document_type: "",
    });
    const [isEditModalVisible, setIsEditModalVisible] = useState(false);

    // --------------------- Fetch APIs ---------------------
    const fetchAllReports = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/reports/getAllReports`);
            const updated = res.data.data.map((item) => ({
                ...item,
                from_date: item.from_date.split("T")[0],
                end_date: item.end_date.split("T")[0],
            }));
            setAllReports(updated || []);
        } catch (error) {
            console.error("Error fetching reports:", error);
        }
    };

    const getSportsAPI = useMutation({
        mutationKey: ["getAllSports"],
        mutationFn: (params) => getAllSports(params),
        onSuccess: (data) => {
            if (data.totalRecords > 0) {
                setSports(data.data);
            }
        },
    });

    useEffect(() => {
        fetchAllReports();
        const params = { page: 1, limit: 100, sort: 1, search: "" };
        getSportsAPI.mutate(params);
    }, []);


    useEffect(() => {
        if (selectedSport) {
            axios
                .get(
                    `${process.env.REACT_APP_BASE_URL}/media/admin/getEvents/${selectedSport}`
                )
                .then((response) => {
                    if (response.status) {
                        setDisciplines(response?.data?.data?.records);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching events:", error);
                });
        } else {
            setDisciplines([]);
        }
    }, [selectedSport]);

    // --------------------- Handlers ---------------------


    const handleDocumentTypeChange = (e) => {
        setDocumentType(e.target.value);
    }

    const handleSportChange = (e) => {
        const sportId = e.target.value;
        setSelectedSport(sportId);
        // const selected = sports.find((s) => s.sport_id.toString() === sportId);

        // if (selected) {
        //     setDisciplines(selected.disciplines || []);
        // } else {
        //     setDisciplines([]);
        // }
    };

    const handleDisciplineChange = (e) => {
        if (!e.target.value) {
            setEvent(null);
            return;
        }
        const parsed = JSON.parse(e.target.value);
        setEvent({
            sport_name: parsed.sport_name,
            sport_id: parsed.nsrs_sport_id,
            discipline_name: parsed.nsrs_game_event_name,
            discipline_id: parsed.nsrs_game_event_id,
        });
    };

    const handlePdfFileChange = (e) => {
        const file = e.target.files[0];
        if (file) setPdfFile(file);
    };

    const handleSubmit = async () => {
        if (!pdfFile) return Swal.fire("Please Add PDF file!");
        if (!fromDate || !toDate) return Swal.fire("Dates are Required!");

        const formData = new FormData();
        formData.append("documentType", documentType);
        formData.append("selectSport", selectedSport);
        formData.append("selectEvent", JSON.stringify(event));
        formData.append("fromDate", fromDate);
        formData.append("toDate", toDate);
        formData.append("documnetTitle", documentTitle);
        formData.append("pdfFile", pdfFile);

        try {
            console.log(formData);
            setIsLoading(true);
            await axios.post(`${BASE_URL}/reports/reportDocument`, formData);
            Swal.fire("Success!", "Data Added Successfully!", "success");
            fetchAllReports();
        } catch (error) {
            Swal.fire("Oops...", "Something went wrong!", "error");
            console.error("Submit error:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`${BASE_URL}reports/deleteReport/${id}`);
            Swal.fire("Deleted!", "Deleted Report Successfully", "success");
            fetchAllReports();
        } catch (err) {
            Swal.fire("Oops...", err.response?.data?.error || "Delete failed", "error");
        }
    };

    const handleEdit = (index) => {
        const selectedItem = allReports[index];
        setEditedData({ ...selectedItem });
        setIsEditModalVisible(true);
    };

    const handleSave = async () => {
        console.log("working 1")
        try {
            const response = await fetch(
                `${BASE_URL}/reports/updateReport/${editedData.id}`,
                {
                    method: "PATCH",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        from_date: editedData.from_date,
                        end_date: editedData.end_date,
                        document_type: editedData.document_type,
                    }),
                }
            );
            console.log(response)

            if (response.ok) {
                Swal.fire("Updated!", "Report Details Updated Successfully!", "success");
                setIsEditModalVisible(false);
                fetchAllReports();
            } else {
                Swal.fire("Oops...", "Failed to Update Data!", "error");
            }
        } catch (error) {
            Swal.fire("Oops...", "Failed to Update Data!", "error");
        }
    };

    // --------------------- Render ---------------------
    return (
        <div className="container-fluid my-4">
            {/* Edit Modal */}
            {isEditModalVisible && (
                <div
                    className="modal show fade d-block"
                    tabIndex="-1"
                    role="dialog"
                    style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                >
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content p-3">
                            <div className="modal-header">
                                <h5 className="modal-title">Edit Report</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setIsEditModalVisible(false)}
                                />
                            </div>
                            <div className="modal-body">
                                <p><b>Sport:</b> {editedData.document_type}</p>
                                <p><b>Sport:</b> {editedData.sport}</p>
                                <p><b>Discipline:</b> {editedData.discipline_name}</p>

                                <div className="mb-3">
                                    <label>From Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={editedData.from_date}
                                        onChange={(e) =>
                                            setEditedData({ ...editedData, from_date: e.target.value })
                                        }
                                    />
                                </div>
                                <div className="mb-3">
                                    <label>To Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={editedData.end_date}
                                        onChange={(e) =>
                                            setEditedData({ ...editedData, end_date: e.target.value })
                                        }
                                    />
                                </div>
                                <div className="mb-3">
                                    <label>Document Title</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={editedData.document_title}
                                        onChange={(e) =>
                                            setEditedData({ ...editedData, document_title: e.target.value })
                                        }
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-primary" onClick={handleSave}>
                                    Save Changes
                                </button>
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => setIsEditModalVisible(false)}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Loader */}
            {isLoading &&
                <CCard>
                    <CCardBody className="flex justify-content-center align-items-center">
                        <CustomLoader />
                    </CCardBody>
                </CCard>}

            {/* Form */}
            <h2 className="mb-4">Add Reports</h2>
            <div className="card p-4 shadow-sm mb-5">
                <div className="row g-3">
                    <div className="col-md-4">
                        <label>Document Type</label>
                        <select
                            className="form-select"
                            value={documentType}
                            onChange={handleDocumentTypeChange}
                        >
                            <option value="">Choose Document Type</option>
                            {DocumentTypes.map((item) => (
                                <option key={item.id} value={item.name}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-4">
                        <label>Sport Discipline</label>
                        <select
                            className="form-select"
                            value={selectedSport}
                            onChange={handleSportChange}
                        >
                            <option value="">Choose Sport Discipline</option>
                            {sports.map((item) => (
                                <option key={item.sport_id} value={item.sport_id}>
                                    {item.sport_name}
                                </option>
                            ))}
                        </select>
                    </div>


                    <div className="col-md-4">
                        <label>Event Name</label>
                        <select className="form-select" onChange={handleDisciplineChange}>
                            <option value="">Choose Event</option>
                            {disciplines.map((d) => (
                                <option key={d.nsrs_game_event_id} value={JSON.stringify(d)}>
                                    {d.nsrs_game_event_name} ({d.gender})
                                </option>
                            ))}
                        </select>
                    </div>


                    <div className="col-md-4">
                        <label>From Date</label>
                        <input
                            type="date"
                            className="form-control"
                            onChange={(e) => setFromDate(e.target.value)}
                        />
                    </div>
                    <div className="col-md-4">
                        <label>To Date</label>
                        <input
                            type="date"
                            className="form-control"
                            onChange={(e) => setToDate(e.target.value)}
                        />
                    </div>
                    <div className="col-md-4">
                        <label>Document Title</label>
                        <input
                            type="text"
                            className="form-control"
                            onChange={(e) => setDocumentTitle(e.target.value)}
                        />
                    </div>
                    <div className="col-md-4">
                        <label>Upload PDF</label>
                        <input
                            type="file"
                            className="form-control"
                            accept=".pdf"
                            onChange={handlePdfFileChange}
                        />
                    </div>
                </div>
                <div className="mt-3 text-end">
                    {/* <button className="btn btn-success" onClick={handleSubmit}>
                        Submit
                    </button> */}
                    <CButton type="submit" onClick={handleSubmit}>Submit</CButton>
                </div>
            </div>

            {/* Reports Table */}
            <h3>Report Documents</h3>
            <div className="table-responsive">
                <table className="table table-bordered table-striped text-center">
                    <thead className="table-dark">
                        <tr>
                            <th>Document Type</th>
                            <th>Sport</th>
                            <th>Discipline</th>
                            <th>From Date</th>
                            <th>To Date</th>
                            <th>Document Title</th>
                            <th>PDF</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {allReports.map((record, idx) => (
                            <tr key={record.id}>
                                <td>{record.document_type}</td>
                                <td>{record.sport}</td>
                                <td>{record.discipline_name}</td>
                                <td>{record.from_date}</td>
                                <td>{record.end_date}</td>
                                <td>{record?.document_title}</td>
                                <td>
                                    <button
                                        className="btn btn-link"
                                        onClick={() => window.open(process.env.REACT_APP_SERVER_URL + "/" + record.pdf_link, "_blank")}
                                    >
                                        View PDF
                                    </button>
                                </td>
                                <td>
                                    <button
                                        className="btn btn-warning btn-sm me-2"
                                        onClick={() => handleEdit(idx)}
                                    >
                                        Edit
                                    </button>
                                    <button
                                        className="btn btn-danger btn-sm"
                                        onClick={() => handleDelete(record.id)}
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                        {allReports.length === 0 && (
                            <tr>
                                <td colSpan="7">No reports available</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default Index;
